import { render, staticRenderFns } from "./OTCTra.vue?vue&type=template&id=2869b07b&scoped=true&"
var script = {}
import style0 from "./OTCTra.vue?vue&type=style&index=0&id=2869b07b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2869b07b",
  null
  
)

export default component.exports